import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  ChartLineUp, Wallet, ArrowsLeftRight, Target, ChartPieSlice,
  Tag, SignOut,
} from "@phosphor-icons/react";

const nav = [
  { to: "/", label: "Dashboard", icon: ChartLineUp, testid: "nav-dashboard" },
  { to: "/transactions", label: "Transactions", icon: ArrowsLeftRight, testid: "nav-transactions" },
  { to: "/budgets", label: "Budgets", icon: Target, testid: "nav-budgets" },
  { to: "/analytics", label: "Analytics", icon: ChartPieSlice, testid: "nav-analytics" },
  { to: "/categories", label: "Categories", icon: Tag, testid: "nav-categories" },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-obsidian text-white flex">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-white/10 bg-[#0A0A0A] flex flex-col fixed h-screen">
        <div className="px-6 py-7 border-b border-white/10 flex items-center gap-3">
          <div className="h-9 w-9 rounded-md bg-cyan flex items-center justify-center">
            <Wallet size={20} weight="fill" className="text-black" />
          </div>
          <span className="font-heading font-extrabold text-xl tracking-tighter">Ledgerly</span>
        </div>

        <nav className="flex-1 px-3 py-6 space-y-1">
          {nav.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={n.testid}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-cyan/10 text-cyan border border-cyan/20"
                      : "text-[#A1A1AA] hover:text-white hover:bg-white/[0.04] border border-transparent"
                  }`
                }
              >
                <Icon size={18} weight="duotone" />
                {n.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="px-3 py-4 border-t border-white/10">
          <div className="px-3 py-2 mb-2">
            <p className="text-sm font-semibold truncate" data-testid="sidebar-user-name">{user?.name}</p>
            <p className="text-xs text-[#52525B] truncate">{user?.email}</p>
            <p className="text-xs text-cyan mt-1 num">Base: {user?.baseCurrency}</p>
          </div>
          <button
            onClick={handleLogout}
            data-testid="logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium text-[#A1A1AA] hover:text-expense hover:bg-expense/10 transition-colors"
          >
            <SignOut size={18} weight="duotone" />
            Log out
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 ml-64 min-h-screen">
        <Outlet />
      </main>
    </div>
  );
}
